import { ReactNode, useEffect } from 'react'
import { rucksack } from '@black-bear-energy/rucksack'
import { AppHeader } from './AppHeader'
import { ContentContainer } from './ContentContainer'
import { HeaderBreadcrumbsProvider } from './HeaderBreadcrumbsContext'
import { NavigationProvider } from './NavigationContext'
import { SideNavigation } from './SideNavigation'
import { WideContentProvider } from './WideContentContext'

/** Props for {@link AppLayout}. */
interface AppLayoutProps {
  /** Page content rendered inside the main content area. */
  children: ReactNode
}

/** Main layout wrapper composing the header, side navigation, and content area. */
export function AppLayout({ children }: AppLayoutProps) {
  useEffect(() => {
    const previous = document.body.style.backgroundColor
    document.body.style.backgroundColor = rucksack.palette.background.navigation
    return () => {
      document.body.style.backgroundColor = previous
    }
  }, [])

  return (
    <NavigationProvider>
      <WideContentProvider>
        <HeaderBreadcrumbsProvider>
          <AppHeader />
          <SideNavigation />
          <ContentContainer>{children}</ContentContainer>
        </HeaderBreadcrumbsProvider>
      </WideContentProvider>
    </NavigationProvider>
  )
}
